export default "__VITE_ASSET__Hl7ghXNL__"